import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';

import './styles.scss';

export function EmptyState({ contactLabel }) {
  return (
    <div className="empty-contacts">
      <h1 className="icons">
        <FontAwesomeIcon className="icon" icon={faUser} />
        <FontAwesomeIcon className="icon" icon={faBriefcase} />
      </h1>

      <div className="description">
        No {pluralize(contactLabel)} have been added
      </div>
    </div>
  );
}

EmptyState.propTypes = {
  contactLabel: PropTypes.string.isRequired,
};

EmptyState.defaultProps = {
  contactLabel: 'contacts',
};

export default EmptyState;
